<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-04-15 10:33:13
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-08 15:45:11
 * @FilePath: \partner.chaoyongtuan.com\src\views\personal\center\dialog\follow.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="follow">
		<el-dialog title="关注公众号" width="30%" :visible.sync="visible">
			<div class="official">
				<p>微信扫描以下二维码，关注{{ baseInfo.website_title }}公众号，可接收达人招商的查看、选品、申样等提醒</p>
				<img :src="wxUrl" alt="" />
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="visible = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import mixin from '@/mixins';
import { checkFollow } from '@/api/common';
export default {
	name: 'follow',
	mixins: [mixin],
	data() {
		return {
			visible: false,
			wxUrl: '',
		};
	},
	methods: {
		show() {
			this.visible = true;
			this.getHead();
		},
		async getHead() {
			const { code, data } = await checkFollow({});
			if (code !== 0) return;
			this.wxUrl = data.wx_url;
		},
	},
};
</script>
<style lang="less" scoped>
.official {
	display: flex;
	flex-direction: column;
	align-items: center;
	img {
		margin-top: 10px;
		width: 200px;
		height: 200px;
	}
}
</style>
